import styled, { keyframes } from "styled-components";
import { LOADING_GREY, MODAL_BACKGROUND } from "@/constants/colors";

const shineFrames = keyframes`{
  0 {
    background-position: 0 0;
  }
  20% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 100% 100%;
  }
}`;

export const LoadingPill = styled.div`
  width: ${({ width }) => width}px;
  background-color: ${LOADING_GREY};
  height: 16px;
  border-radius: 16px;
  background-image: linear-gradient(
    135deg,
    ${LOADING_GREY} 0%,
    ${MODAL_BACKGROUND} 40%,
    ${LOADING_GREY} 60%,
    ${LOADING_GREY} 100%
  );
  background-size: 400%;
  animation: ${shineFrames} 2s infinite ease-in-out;
  animation-direction: reverse;
`;
